import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';
import { isArrayEqual } from '@/app/utils/utils';
import ToolkitMixin from '@/app/mixins/toolkit/item';
import { defaultMemberInfo } from '@/app/utils/toolkit/defaults/defaultInvStrat';
import Members from './members/members.vue';

export default {
  name: 'inv-strat-member-info',
  components: {
    Members,
  },
  mixins: [ToolkitMixin],
  computed: {
    fundMembers() {
      return this.$store.getters['fund/getFundMembers'];
    },
    members: {
      get() {
        return this.getItem.members;
      },
      set(val) {
        this.setItem({ members: val });
      },
    },
    memberInfo: {
      get() {
        if (this.getItem.memberInfo === null) {
          return null;
        }
        return (this.getItem.memberInfo === true ? 'Yes' : 'No');
      },
      set(value) {
        this.setItem({
          memberInfo: (value === 'Yes'),
        });
      },
    },
  },
  methods: {
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
  mounted() {
    const fundMembers = this.fundMembers.map(member => ({
      ..._.cloneDeep(member),
      additionalInfo: {
        ..._.cloneDeep(defaultMemberInfo),
      },
    }));

    if (!isArrayEqual(fundMembers, this.members)) {
      const mergedMembers = _.merge(_.keyBy(_.cloneDeep(fundMembers), 'uuid'), _.keyBy(_.cloneDeep(this.members), 'uuid'));
      const fundMemberIDS = fundMembers.map(member => member.uuid);
      const members = _.values(_.pick(mergedMembers, fundMemberIDS));
      this.members = members.map(member => ({
        ...fundMembers.filter(item => member.uuid === item.uuid)[0],
        additionalInfo: member.additionalInfo,
      }));
    }
  },
  validations() {
    if (this.memberInfo === 'Yes') {
      return {
        memberInfo: {
          required,
        },
        members: {
          $each: {
            additionalInfo: {
              currentWorkStatus: {
                value: {
                  required,
                },
              },
              contributionPlans: {
                value: {
                  required,
                },
              },
              incomeNeeds: {
                value: {
                  required,
                },
              },
              longTermIncomeNeeds: {
                value: {
                  required,
                },
              },
              riskAppetite: {
                value: {
                  required,
                },
              },
            },
          },
        },
      };
    }
    return {
      memberInfo: {
        required,
      },
    };
  },
};
